"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Icon_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/Icon/Icon"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var EventStartsSoon_1 = __importDefault(require("../../../Icons/Notifications/EventStartsSoon"));
var interval;
function Countdown(_a) {
    var startDate = _a.startDate;
    var _b = (0, react_1.useState)(undefined), minutes = _b[0], setMinutes = _b[1];
    var _c = (0, react_1.useState)(undefined), seconds = _c[0], setSeconds = _c[1];
    (0, react_1.useEffect)(function () {
        interval = setInterval(function () {
            var eventStartDate = new Date(startDate).getTime();
            var distance = eventStartDate - Date.now();
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            setMinutes(minutes);
            setSeconds(seconds);
            if (distance < 0) {
                setMinutes(0);
                setSeconds(0);
                clearInterval(interval);
            }
        }, 1000);
        return function () { return clearInterval(interval); };
    }, [setMinutes, setSeconds]);
    var minutesString = minutes !== undefined
        ? minutes.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        })
        : '--';
    var secondsString = seconds !== undefined
        ? seconds.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        })
        : '--';
    return (react_1.default.createElement("div", { className: "notification-item__countdown" },
        react_1.default.createElement(Icon_1.default, { name: "clock outline" }), "".concat(minutesString, ":").concat(secondsString)));
}
var i18N = {
    en: {
        description: function (metadata) {
            return new Date(metadata.startsAt).getTime() > Date.now() ? (react_1.default.createElement(react_1.default.Fragment, null,
                "The event ",
                react_1.default.createElement("a", { href: metadata.link }, metadata.name),
                " is about to start in ",
                react_1.default.createElement(Countdown, { startDate: metadata.startsAt }))) : (react_1.default.createElement(react_1.default.Fragment, null,
                "The event ",
                react_1.default.createElement("a", { href: metadata.link }, metadata.name),
                " starts in an hour"));
        },
        title: 'Event starts soon'
    },
    es: {
        description: function (metadata) {
            return new Date(metadata.startsAt).getTime() > Date.now() ? (react_1.default.createElement(react_1.default.Fragment, null,
                "El evento ",
                react_1.default.createElement("a", { href: metadata.link }, metadata.name),
                " esta por empezar en ",
                react_1.default.createElement(Countdown, { startDate: metadata.startsAt }))) : (react_1.default.createElement(react_1.default.Fragment, null,
                "El evento ",
                react_1.default.createElement("a", { href: metadata.link }, metadata.name),
                " empieza en una hora"));
        },
        title: 'Evento empieza pronto'
    },
    zh: {
        description: function (metadata) {
            return new Date(metadata.startsAt).getTime() > Date.now() ? (react_1.default.createElement(react_1.default.Fragment, null,
                "\u4E8B\u4EF6 ",
                react_1.default.createElement("a", { href: metadata.link }, metadata.name),
                " \u5373\u5C06\u5F00\u59CB \u5728",
                ' ',
                react_1.default.createElement(Countdown, { startDate: metadata.startsAt }))) : (react_1.default.createElement(react_1.default.Fragment, null,
                "\u4E8B\u4EF6 ",
                react_1.default.createElement("a", { href: metadata.link }, metadata.name),
                " \u4ECE\u4E00\u4E2A\u5F00\u59CB \u5C0F\u65F6"));
        },
        title: '事件即将开始'
    }
};
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
var EventsStartsSoonNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(EventStartsSoon_1.default, { width: "48", height: "48" }) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title),
        react_1.default.createElement("a", { href: notification.metadata.link },
            react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata)))));
};
exports.default = EventsStartsSoonNotification;
